import { StyledEmployeeBox } from '../hooks/useGetColumns.styles';
import { StyledTypographyNormalLineHeightSemiBold } from 'components/shared/Typography/Typography.styles';
import { StyledBoxCenterExtraSmallGap } from 'components/shared/Box/Box.styles';
import { IconContainer } from 'components/shared/Header/Header.styles';
import theme from 'config/theme';
import { Icon } from '@sdb/planning-ui';
import { useTranslation } from 'react-i18next';

const EmployeeHeader = ({
  showSourceCostCenter,
  showCommitmentCostCenter
}: {
  showSourceCostCenter?: boolean;
  showCommitmentCostCenter?: boolean;
}) => {
  const { t } = useTranslation('common', {
    keyPrefix: 'rosterPlan'
  });

  return (
    <StyledEmployeeBox>
      <StyledTypographyNormalLineHeightSemiBold variant="subtitle1">
        {t('dataGrid.employee')}
      </StyledTypographyNormalLineHeightSemiBold>
      <StyledBoxCenterExtraSmallGap>
        {showSourceCostCenter && (
          <>
            <StyledTypographyNormalLineHeightSemiBold variant="body2">
              {t('dataGrid.employeeSource')}
            </StyledTypographyNormalLineHeightSemiBold>
            {showCommitmentCostCenter && (
              <IconContainer
                iconColor={theme.palette.text.secondary}
                iconSize="SMALL"
              >
                <Icon type="arrow-right" color="inherit" />
              </IconContainer>
            )}
          </>
        )}
        {showCommitmentCostCenter && (
          <StyledTypographyNormalLineHeightSemiBold variant="body2">
            {t('dataGrid.employeeCommitment')}
          </StyledTypographyNormalLineHeightSemiBold>
        )}
      </StyledBoxCenterExtraSmallGap>
    </StyledEmployeeBox>
  );
};

export default EmployeeHeader;
